import React, { Component } from "react";
import UrlInput from "./UrlInput";

export class Competitors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      competitors: this.props.competitors
    };

    this.getCompetitor = this.getCompetitor.bind(this);
    this.getValidationMessage = this.getValidationMessage.bind(this);
  }

  getCompetitor(competitor) {
    let competitors = [...this.state.competitors];

    let modifiedCompetitorIdx = competitors.findIndex(comp => comp.id === competitor.id);
    if (modifiedCompetitorIdx > -1 && !["https://", "http://"].includes(competitor["url"])) {
      competitors[modifiedCompetitorIdx] = competitor;
    } else if (modifiedCompetitorIdx > -1 && ["https://", "http://"].includes(competitor["url"])) {
      competitors.splice(modifiedCompetitorIdx, 1);
    } else {
      competitors.push(competitor);
    }
    competitors.sort((a, b) => {
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    });

    this.setState({ competitors: competitors });
    this.props.sendCompetitors(competitors, competitor["id"]);
  }

  getValidationMessage(id) {
    let validation = this.props.competitorsValidation.find(competitorValidation => competitorValidation["id"] === id);
    if (!validation) {
      return undefined;
    }
    return validation["validation"];
  }

  render() {
    return (
      <div className="wizard-competitors-form">
        {[...Array(this.props.maxCompetitorsNo)].map((item, index) => {
          let competitor = this.props.competitors.filter(comp => comp.id === `competitor${index}`)[0];

          return (
            <UrlInput
              key={index}
              placeholder={`competitor${index + 1}.com`}
              id={`competitor${index}`}
              url={competitor ? competitor["url"] : ""}
              urlSchema={competitor ? competitor["urlSchema"] : "https://"}
              sendUrl={this.getCompetitor}
              validationError={this.getValidationMessage(`competitor${index}`)}
            />
          );
        })}
      </div>
    );
  }
}

export default Competitors;
